module.exports = __webpack_public_path__ + "static/img/1679717062889.173975c.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/1679717062889.png
// module id = IyZO
// module chunks = 1